import React from "react";
import './styles.css';

export const Footer = () => {
  return (
    <footer className="footer">
      <p className="footer-text">Agência M3 - Agência de Performance Digital</p>
    </footer>
  )
}